import { useAnalytics } from 'libs/utils/site/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const useRouterListener = () => {
    const analytics = useAnalytics();
    const location = useLocation();

    useEffect(() => {
        analytics.track('page.view');
        // Hubspot refresh so it knows if chat should be shown
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).HubSpotConversations?.widget?.refresh?.();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
};
